import React from 'react';

/**
 * DirhamIcon - أيقونة الدرهم الإماراتي
 */
const DirhamIcon = ({ className = "w-4 h-4", style = {}, color = "white" }) => {
  const getFilter = () => {
    switch(color) {
      case 'primary':
      case 'gold':
      case 'yellow':
        return 'brightness(0) saturate(100%) invert(73%) sepia(51%) saturate(497%) hue-rotate(6deg) brightness(94%) contrast(88%)';
      case 'green':
        return 'brightness(0) saturate(100%) invert(48%) sepia(79%) saturate(2476%) hue-rotate(86deg) brightness(118%) contrast(119%)';
      case 'red':
        return 'brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%) hue-rotate(346deg) brightness(104%) contrast(97%)';
      case 'cyan':
      case 'teal':
        return 'brightness(0) saturate(100%) invert(70%) sepia(52%) saturate(5619%) hue-rotate(150deg) brightness(101%) contrast(101%)';
      case 'gray':
      case 'muted':
        return 'brightness(0) saturate(100%) invert(50%)';
      case 'white':
      default:
        return 'brightness(0) invert(1)';
    }
  };

  return (
    <img 
      src="/icons/dirham-transparent.png" 
      alt="درهم"
      className={className}
      style={{ 
        display: 'inline-block',
        verticalAlign: 'baseline',
        position: 'relative',
        top: '0.1em',
        filter: getFilter(),
        ...style 
      }}
    />
  );
};

/**
 * DirhamIconColored - أيقونة الدرهم بلون مخصص
 */
export const DirhamIconColored = ({ className = "w-4 h-4", colorClass = "", style = {}, color = "" }) => {
  const getFilterFromClass = () => {
    const cls = colorClass || color || className;
    
    // Primary/Gold colors
    if (cls.includes('primary') || cls.includes('gold') || cls.includes('yellow') || cls.includes('amber')) {
      return 'brightness(0) saturate(100%) invert(73%) sepia(51%) saturate(497%) hue-rotate(6deg) brightness(94%) contrast(88%)';
    }
    // Green colors
    if (cls.includes('green') || cls.includes('emerald')) {
      return 'brightness(0) saturate(100%) invert(48%) sepia(79%) saturate(2476%) hue-rotate(86deg) brightness(118%) contrast(119%)';
    }
    // Red colors
    if (cls.includes('red') || cls.includes('rose') || cls.includes('destructive')) {
      return 'brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%) hue-rotate(346deg) brightness(104%) contrast(97%)';
    }
    // Cyan/Teal colors
    if (cls.includes('cyan') || cls.includes('teal')) {
      return 'brightness(0) saturate(100%) invert(70%) sepia(52%) saturate(5619%) hue-rotate(150deg) brightness(101%) contrast(101%)';
    }
    // Blue colors
    if (cls.includes('blue')) {
      return 'brightness(0) saturate(100%) invert(37%) sepia(93%) saturate(7471%) hue-rotate(215deg) brightness(95%) contrast(93%)';
    }
    // Gray/Muted colors
    if (cls.includes('gray') || cls.includes('muted') || cls.includes('zinc') || cls.includes('slate')) {
      return 'brightness(0) saturate(100%) invert(50%)';
    }
    // Default white for dark backgrounds
    return 'brightness(0) invert(1)';
  };

  return (
    <img 
      src="/icons/dirham-transparent.png" 
      alt="درهم"
      className={className}
      style={{ 
        display: 'inline-block',
        verticalAlign: 'baseline',
        position: 'relative',
        top: '0.1em',
        filter: getFilterFromClass(),
        ...style 
      }}
    />
  );
};

/**
 * CurrencyDisplay - مكون لعرض المبالغ المالية مع أيقونة الدرهم الإماراتي
 */
const CurrencyDisplay = ({ 
  amount, 
  className = "", 
  iconSize = "w-5 h-5",
  showIcon = true,
  decimals = 2,
  useLocale = false,
  color = ""
}) => {
  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
  
  const formattedAmount = useLocale 
    ? numAmount?.toLocaleString() 
    : numAmount?.toFixed(decimals);

  return (
    <span className={`inline-flex items-center gap-1 ${className}`}>
      <span>{formattedAmount}</span>
      {showIcon && (
        <DirhamIconColored 
          className={iconSize} 
          colorClass={className}
          color={color}
        />
      )}
    </span>
  );
};

/**
 * CurrencyLabel - للاستخدام في labels الحقول
 */
export const CurrencyLabel = ({ 
  label, 
  className = "",
  iconSize = "w-4 h-4",
  color = ""
}) => {
  return (
    <span className={`inline-flex items-center gap-1 ${className}`}>
      <span>{label}</span>
      <span>(</span>
      <DirhamIconColored className={iconSize} colorClass={className} color={color} />
      <span>)</span>
    </span>
  );
};

export { DirhamIcon };
export default CurrencyDisplay;
